import { Root } from '@/components/list/flightlist/types';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function debounce(func: any, wait: any, immediate = false) {
  let timeout: any;
  return function (this: any, ...args: any[]) {
    const context = this;
    clearTimeout(timeout);
    if (immediate && !timeout) func.apply(context, args);
    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
  };
}

export const formatCurrency = (value: number) => {
  if (typeof window === 'undefined') {
    return null;
  }
  // Fetch locale and currency from sessionStorage
  const locale = sessionStorage.getItem('locale') || 'en-US'; // Default to 'en-US' if not found
  const currency = sessionStorage.getItem('currency') || 'INR'; // Default to 'USD' if not found

  // Format the currency
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2, // Adjust as needed
  }).format(value);
};

export const throttle = (func: any, limit: any) => {
  let inThrottle = false;
  return function (this: any, ...args: any[]) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => {
        inThrottle = false;
      }, limit);
    }
  };
};

export const getDataForCartApi = (data: Root, priceDetails: any) => {
  const paramsData = {
    data: [],
    fareRules: [],
    fare_details: [],
    priceIds: [],
    trip_type: 'DO',
  };
  if (!data || !priceDetails) {
    return [];
  }
  const selectedFlight: Root = JSON.parse(JSON.stringify(data));
  const selectedBucket = JSON.parse(JSON.stringify(priceDetails));
  const {
    fareTypeId,
    refundableType,
    popover_info,
    netCommission,
    commission_tds,
    netFare,
  } = selectedBucket;
  (selectedFlight as any)['ticket_id'] = selectedBucket?.ticket_id;
  (selectedFlight as any)['r_flight_itinerary_id'] =
    selectedBucket?.r_flight_itinerary_id;
  (selectedFlight as any)['passenger'] = {
    adult: 1,
    child: 0,
    infant: 0,
  };
  (selectedFlight as any)['passengers'] = 1;
  (paramsData as any)?.priceIds?.push(selectedBucket?.ticket_id);
  (selectedFlight as any)['checkin_baggage'] = selectedBucket?.checkin_baggage
    ? selectedBucket?.checkin_baggage
    : selectedFlight?.checkin_baggage;
  (selectedFlight as any)['hand_baggage'] = selectedBucket?.hand_baggage
    ? selectedBucket?.hand_baggage
    : selectedFlight?.hand_baggage;
  (selectedBucket as any)['booking_class'] = popover_info?.[1].value;
  (selectedBucket as any)['fare_basis'] = popover_info?.[2].value;
  (selectedFlight as any)['price_details'] = selectedBucket;
  const fareRules = {
    airline_code: selectedFlight?.airline_name,
    origin: selectedFlight?.origin,
    destination: selectedFlight.destination,
    supplier: selectedBucket?.supplier_code,
    travel_type: 'DO',
    trip_type: 'DO', // dynamic
    cabin_type: 'EC', //dynamic
    fareTypeId,
    refundType: refundableType,
    departureDate: (selectedFlight as any).data,
    bookingClass: popover_info?.[1].value,
    fareBasis: popover_info?.[2].value,
  };
  (paramsData as any)?.fareRules?.push(fareRules);
  (paramsData as any)?.data?.push(selectedFlight);

  return paramsData;
};
